export function changeStatus(type, message) {
    return {
        type: type,
        message: message,
    };
}
